import { API_ROUTE } from "../constants/workerConstants";
import AxiosInstance from "./http.handlers";

export const GetContact = async () => {
  return await AxiosInstance.get(`${API_ROUTE.CONTACT.GET_CONTACTS}`)
    .then((response) => response)
    .catch((error) => error);
};
